import { store } from '@utils/configStore'
import { bannerNotificationManagementReducer } from './slice'

export const injectBannerNotificationManagementStore = () => store.injectReducer('bannerNotificationManagement', bannerNotificationManagementReducer)
